/**
 * The backend's envelope is `{ message, code, extra }`. Without this a failed
 * write is silent: the button greys out and nothing else happens.
 */
export const onboardingErrorMessage = (error: unknown): string | undefined => {
  if (!(error instanceof Error)) return undefined;

  // `requestJson` and `requestVoid` already read the envelope into an
  // ApiError; only the multipart helper still throws the raw body. Checked by
  // shape so this module does not pull the API client into every test that
  // imports it.
  const code = (error as { code?: unknown }).code;
  if (typeof code === 'string' && code) return error.message;

  const start = error.message.indexOf('{');
  const end = error.message.lastIndexOf('}');

  if (start === -1 || end <= start) return undefined;

  const body = error.message.slice(start, end + 1);

  try {
    const parsed: unknown = JSON.parse(body);

    if (parsed && typeof parsed === 'object' && 'message' in parsed) {
      const { message } = parsed as { message?: unknown };

      return typeof message === 'string' && message ? message : undefined;
    }
  } catch {
    // A body that is not the envelope tells the manager nothing useful.
  }

  return undefined;
};
